import React from 'react';

interface CrosshairProps {
  pos: React.CSSProperties;
  color?: string;
}

function CrosshairMark({ pos, color = '#92de71' }: CrosshairProps) {
  return (
    <div style={{ position: 'absolute', width: 9, height: 9, ...pos, zIndex: 2, pointerEvents: 'none' }}>
      <div style={{ position: 'absolute', left: '50%', top: 0, width: 1, height: '100%', background: color, transform: 'translateX(-0.5px)' }} />
      <div style={{ position: 'absolute', top: '50%', left: 0, height: 1, width: '100%', background: color, transform: 'translateY(-0.5px)' }} />
    </div>
  );
}

interface CrosshairFrameProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  corners?: ('tl' | 'tr' | 'bl' | 'br')[];
  color?: string;
}

export function CrosshairFrame({ children, className = '', style = {}, corners = ['tl', 'tr', 'bl', 'br'], color }: CrosshairFrameProps) {
  const posMap = {
    tl: { top: -5, left: -5 },
    tr: { top: -5, right: -5 },
    bl: { bottom: -5, left: -5 },
    br: { bottom: -5, right: -5 },
  };
  return (
    <div className={className} style={{ position: 'relative', ...style }}>
      {corners.map(c => <CrosshairMark key={c} pos={posMap[c]} color={color} />)}
      {children}
    </div>
  );
}
